import { Menu } from './overlays/Menu'

export function DropdownMenu(props) {
  return <Menu {...props} />
}
